import { FC, memo, useState } from "react";
import { useTranslation } from "react-i18next";
import { call } from "@/services/call";
import { logger } from "@/services/logger";
import { Select } from "@/ui";
import { showErrorToast } from "@/utils/toast";
import { StyledMicrophoneSelect } from "./styled";

const MicrophoneSelect: FC = () => {
  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(call.devices?.currentAudioDeviceId || '');

    const onChange = async (e: string) => {
      try {
        setLoading(true);
        setValue(e);
        await call.switchAudio(e);
      } catch (error) {
        logger.error(error);
        showErrorToast(t('error'), t('something_went_wrong'));
      } finally {
        setLoading(false);
      }
    };

  return (
    <StyledMicrophoneSelect>
      <h4>{t('select_microphone')}</h4>
      <Select
        options={call.devices?.audioDevices.map((item) => ({ label: item.label, value: item.deviceId })) || []}
        value={value}
        disabled={loading}
        onChange={onChange}
      />
    </StyledMicrophoneSelect>
  );
};

export default memo(MicrophoneSelect);
